var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticketDetails" } },
    [
      _c(
        "div",
        { ref: "scrollArea", staticClass: "section-content" },
        [
          _vm.selected
            ? [
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("div", {
                      staticClass: "status",
                      style: {
                        backgroundColor:
                          _vm.$store.getters.company.statuses[
                            _vm.selected.status
                          ].color
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "left" }, [
                      _c("div", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm._f("showProp")(_vm.unit, "title")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "property" }, [
                        _vm._v(_vm._s(_vm._f("showProp")(_vm.property, "name")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c("div", { staticClass: "date" }, [
                        _vm._v(
                          _vm._s(_vm._f("dateShorthand")(_vm.selected.created))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "status-text" }, [
                        _vm._v(_vm._s(_vm.selected.status))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "details" }, [
                    _c("div", { staticClass: "section" }, [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("Ticket Details "),
                        _c("span", { staticClass: "number" }, [
                          _vm._v("#" + _vm._s(_vm.selected.number))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "title-value" }, [
                        _vm._v(_vm._s(_vm.selected.title))
                      ]),
                      _vm._v(" "),
                      _vm.editing
                        ? _c(
                            "div",
                            { staticClass: "description" },
                            [
                              _c("v-text-field", {
                                ref: "inputDescription",
                                attrs: {
                                  disabled: _vm.descLockout,
                                  rules: _vm.rules.description,
                                  "no-resize": "",
                                  "multi-line": "",
                                  rows: 3,
                                  label: "Description"
                                },
                                model: {
                                  value: _vm.ticket.body,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ticket, "body", $$v)
                                  },
                                  expression: "ticket.body"
                                }
                              })
                            ],
                            1
                          )
                        : _c("div", { staticClass: "description" }, [
                            _vm._v(_vm._s(_vm.ticket.body))
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "section" }, [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("\n              Images\n              "),
                        _c(
                          "div",
                          { staticClass: "button" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  fab: "",
                                  small: "",
                                  disabled: _vm.selected.images.length >= 15
                                },
                                on: {
                                  click: function($event) {
                                    _vm.routeAddQuery(
                                      "dialog",
                                      "ticket-add-images"
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("mdi-plus")])],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      (_vm.selected.images && _vm.selected.images.length > 0) ||
                      (_vm.selected.pendingImages &&
                        _vm.selected.pendingImages > 0)
                        ? _c(
                            "div",
                            { staticClass: "image-preview" },
                            [
                              _vm._l(_vm.selected.images, function(image, i) {
                                return _c("div", {
                                  key: "image" + i,
                                  staticClass: "image-thumb",
                                  style: {
                                    "background-image": "url(" + image.uri + ")"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.openGallery(i)
                                    }
                                  }
                                })
                              }),
                              _vm._v(" "),
                              _vm.selected.pendingImages &&
                              _vm.selected.pendingImages >
                                (_vm.selected.images
                                  ? _vm.selected.images.length
                                  : 0)
                                ? _vm._l(
                                    _vm.selected.pendingImages -
                                      (_vm.selected.images
                                        ? _vm.selected.images.length
                                        : 0),
                                    function(image, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: "pending" + i,
                                          staticClass: "image-thumb"
                                        },
                                        [
                                          _c("v-progress-circular", {
                                            staticStyle: {
                                              position: "absolute",
                                              margin: "0 auto",
                                              top: "37px",
                                              left: "37px"
                                            },
                                            attrs: {
                                              indeterminate: "",
                                              color: "primary",
                                              size: 40
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "clear" })
                            ],
                            2
                          )
                        : _c("div", [
                            _c("div", { staticClass: "images-empty" }, [
                              _vm._v("No Images")
                            ])
                          ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "section",
                        staticStyle: { "margin-bottom": "0px" }
                      },
                      [
                        _c("div", { staticClass: "section-title" }, [
                          _vm._v("Unit Details")
                        ]),
                        _vm._v(" "),
                        _vm.unit || _vm.property
                          ? _c("div", { staticClass: "icon-section" }, [
                              _c("i", {
                                staticClass: "icon mdi mdi-24px mdi-home"
                              }),
                              _vm._v(" "),
                              _vm.unit
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      class: {
                                        selectable: _vm.hasPermissionsInProperty(
                                          ["unit"],
                                          _vm.selected.property
                                        )
                                      },
                                      on: { click: _vm.openUnit }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("showProp")(_vm.unit, "title")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.property
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      class: {
                                        selectable: _vm.hasPermissions([
                                          "property"
                                        ])
                                      },
                                      on: { click: _vm.openProperty }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("showProp")(
                                            _vm.property,
                                            "name"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.property && _vm.property.address
                          ? _c("div", { staticClass: "icon-section" }, [
                              _c("i", {
                                staticClass: "icon mdi mdi-24px mdi-map-marker"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _vm.property.address.line2.length
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.property.address.line2))
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.property.address.line1) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("showProp")(
                                      _vm.property.address,
                                      "city"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm._f("showProp")(
                                        _vm.property.address,
                                        "province"
                                      )
                                    ) +
                                    ", " +
                                    _vm._s(
                                      _vm._f("showProp")(
                                        _vm.property.address,
                                        "country"
                                      )
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("showProp")(
                                      _vm.property.address,
                                      "postal"
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icon-section" },
                          [
                            _c("i", {
                              staticClass:
                                "icon mdi mdi-24px mdi-account-multiple"
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.ticket.reporters, function(reporter, i) {
                              return _vm.ticket.reporters.length > 0
                                ? _c("div", { key: i, staticClass: "item" }, [
                                    _c(
                                      "div",
                                      { staticClass: "avatar" },
                                      [
                                        _c("vo-avatar", {
                                          attrs: {
                                            user: _vm.$store.getters.user(
                                              reporter
                                            ),
                                            size: 24
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        class: {
                                          selectable: _vm.hasPermissionsInProperty(
                                            ["user"],
                                            _vm.selected.property
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.openUser(reporter)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$store.getters.user(reporter)
                                                .fullName
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm.ticket.reporters.length === 0
                              ? _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "empty" }, [
                                    _vm._v("No users assigned to this unit.")
                                  ])
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.hasPermissions(
                    ["ticketManager", "ticketAdmin"],
                    _vm.selected.property
                  )
                    ? _c(
                        "div",
                        { staticClass: "vo-footer" },
                        [
                          !_vm.editing
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "vo-button",
                                  attrs: { flat: "" },
                                  on: { click: _vm.toggleEditing }
                                },
                                [
                                  _c("v-icon", [_vm._v("mdi-pencil")]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Edit Description")])
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "right" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "vo-button",
                                      attrs: {
                                        disabled: _vm.descLockout,
                                        flat: ""
                                      },
                                      on: { click: _vm.cancelEditDesc }
                                    },
                                    [_c("span", [_vm._v("Cancel")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "vo-button green",
                                      attrs: {
                                        loading: _vm.descLockout,
                                        flat: ""
                                      },
                                      on: { click: _vm.saveEditDesc }
                                    },
                                    [_c("span", [_vm._v("Save")])]
                                  )
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clear" })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.hasPermissions(
                  ["ticketManager", "ticketAdmin"],
                  _vm.selected.property
                )
                  ? _c("vo-ticket-manage-tools", {
                      ref: "ticketManageTools",
                      attrs: { page: _vm.page, selected: _vm.selected }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermissions(
                  ["ticketManager", "ticketAdmin"],
                  _vm.selected.property
                )
                  ? _c("vo-ticket-note", {
                      ref: "ticketNote",
                      attrs: { page: _vm.page, selected: _vm.selected }
                    })
                  : _vm._e()
              ]
            : [_c("vo-empty-state", { attrs: { text: "SELECT A TICKET" } })]
        ],
        2
      ),
      _vm._v(" "),
      _c("vo-details-header", {
        attrs: {
          page: _vm.page,
          rightButton: { icon: "mdi-forum", query: "chat" }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a182296", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a182296","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketDetails.vue
// module id = 599
// module chunks = 4